<script>
  import { onMount } from "svelte";
  import StepBase from "./StepBase.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";

  export let onClickBack

  export let onClickNext

  export let importsBundle

  export let plan

  const ctx = getAutoMpsProjectContext()

  async function createPlan() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/plans`, {
      method: "POST",
      body: JSON.stringify({imports: importsBundle}),
      headers: {
        "Content-Type": "application/json",
      }
    })

    return response.json()
  }

  onMount(async () => {
    plan = await createPlan()
    onClickNext()
  })
</script>

<StepBase onClickBack={onClickBack}>
  <div>
    データのチェックをしています...
  </div>
</StepBase>
